// extracted by mini-css-extract-plugin
export default {"table":"Countries_table__3IV7f"};